module.exports = __webpack_public_path__ + "img/stop.3ad5aa85.svg";